module.exports = __webpack_public_path__ + "static/woman-green-smoothie-square.70c6085f.jpg";